import {
    AccordionContent,
    AccordionIcon,
    AccordionRoot,
    AccordionTrigger
} from "@/app/(site)/_components/Atoms/Accordion"
import AccordionToggleIcon from "@/app/(site)/_components/GCMolecules/AccordionElement/AccordionToggleIcon"
import HeadingElement from "@/app/(site)/_components/GCMolecules/HeadingElement"
import ProductDescriptionText from "@/app/(site)/_components/Page/Product/ProductDetail/ProductDescriptionText"

interface ProductDescriptionAccordionProps {
    header: string
    content: string
    className?: string
}

export default function ProductDescriptionAccordion({
    header,
    content,
    className
}: ProductDescriptionAccordionProps) {
    return (
        <AccordionRoot className={className} initalState={true} hydratedState={true}>
            <AccordionTrigger className="flex w-full items-center justify-between">
                <HeadingElement
                    isAboveTheFold={false}
                    text={header}
                    type="h2"
                    styleKey="Trim_Mono_POC_Text_18_130_-3_400_uppercase"
                />
                <AccordionIcon
                    openIcon={<AccordionToggleIcon isOpen={true} />}
                    closeIcon={<AccordionToggleIcon isOpen={false} />}
                />
            </AccordionTrigger>
            <AccordionContent>
                <ProductDescriptionText content={content} className="pt-20" />
            </AccordionContent>
        </AccordionRoot>
    )
}
